module.exports = __webpack_public_path__ + "img/portrait-103.7d66d18b.jpg";